import { Icon } from "lucide-react"
import styles from "./SecondScreen.module.css"
import IconBox from "../components/EsterBox/Box"
import learn from "../icons/wired-outline-406-study-graduation-hover-pinch (3).json"
import Works from "../components/recommends/Works"
import StudentWorks from "../components/recommends/StudentsWorks"
import Button from "../components/button/Button"
import AboutMe from "../components/me/Me"
import money from "../icons/wired-outline-298-coins-loop-spin (6).json"
import teacher from "../icons/wired-outline-689-speaker-lecturer-female-hover-pinch.json"
import woman from "../icons/wired-outline-3141-female-jumping-hover-jump (2).json"
import shake from "../icons/wired-outline-456-handshake-deal-hover-pinch (2).json"
import nail from "../icons/wired-outline-1596-nails-hover-pinch (5).json"
const SecondScreen=()=>{

    return <>
<div className={styles.title}>לא עוד קורס רגיל - זה הנתיב שלך להצלחה אמיתית.</div>
<div className={styles.description}>ברוכה הבאה ל–Ester Mati Academy – המקום שבו נשים יוצרות עתיד, קריירה, והגשמה אישית דרך עולם הציפורניים.</div>
<div className={styles.title}>אז מה את באמת מחפשת בקורס..?</div>
     <div className={styles.row}>
            <IconBox
          text="מקצוע שיכניס לך כסף מהר " 

          icon={money}
        />
            <IconBox
          text="יחס אישי ושיטה שמביאה תוצאות"
          icon={nail}
        />
        <IconBox
          text="מרצה שאכפת לה ממך באמת"
          icon={teacher}
        />
    
    
      </div>
         <div className={styles.row}>
            <IconBox
          text="ליווי אמיתי גם אחרי הקורס" 

          icon={shake}
        />
            <IconBox
          text="ביטחון לצאת לדרך לבד"
          icon={woman}
        />
  
    
    
      </div>
      <div className={styles.title}>כאן את מקבלת את הכל – ועוד הרבה מעבר.</div>
<div className={styles.description}>פיתחתי שיטה ייחודית משלי שמתאימה לכל אחת! ויכולה להביא כל אחת למצב שהיא עוסקת בתחום איך שהיא יוצאת מהקורס ומוציאה עבודות ברמה של חו׳׳ל מהר מהצפוי!</div>
<div className={styles.title}>ואני אומרת לך את זה בבטחון מלא</div>

<div className={styles.description}>כי לפני 22 שנים, הייתי במקום שלך!</div>
<AboutMe/>


<div className={styles.description}>עברתי בעצמי עשרות קורסים והשתלמויות אצל המורות הכי טובות <strong>בעולם</strong> וייסדתי שיטת בנייה ייחודית שלא נלמדת באף מקום </div>

<Works/>
<StudentWorks/>

  <div className={styles.title}>וזו יכולה להיות את</div>
 <div className={styles.description}>
  התלמידות שלי התחילו בדיוק מהמקום שאת נמצאת בו עכשיו,  
  בלי ניסיון, רק עם אהבה ליופי ורצון להצליח.  
  היום הן עובדות, עצמאיות ומרוויחות ממה שהן אוהבות.
</div>
  <div className={styles.description}>
    
 <strong>הגיע הזמן ללמוד את המקצוע <strong> באמת </strong>ולעשות את הצעד הראשון לעבר קריירה רווחית בתחום</strong>
  </div>

  <Button text="לחצי כאן ונדבר!"/>
 


</>

}
export default SecondScreen